import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Validate from "./lib/validate";
import { Localize } from "./lib/localize";
import Datetime from "vue-datetime";
import Clamp from "./components/Clamp.vue";
import SvgIcon from "./components/SvgIcon.vue";
import User from "../core/User";
import Modal from "./components/Modal.vue";
import { ModalPlugin } from './components/ModalEventBus';

import 'vue-datetime/dist/vue-datetime.css';

Vue.config.productionTip = false;

Vue.use(Validate);
Vue.use(Localize);
Vue.use(Datetime);
Vue.component("Modal", Modal);
Vue.use(ModalPlugin);
Vue.component("v-clamp", Clamp);
Vue.component("svgicon", SvgIcon);
require("./assets/style/global.scss");
require("./assets/style/cogir.scss");
require("./global.js");
require("./lib/firebaseNotifications.js");

function checkWindowSize() {
  store.state.isDesktop = window.innerWidth > 600;
  store.state.isTablet = window.innerWidth > 600 && window.innerWidth < 1100;
}
checkWindowSize();
window.onresize = checkWindowSize;


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

let aclExceptions = ["login", "home", "services", "service", "about", "locale", "accountCreation", "noAccount","resetPassword","welcome"];

router.beforeEach((to, from, next) => {
  if (!User.token && aclExceptions.indexOf(to.name) === -1) {
    next({ path: '/login' });
  } else {
    next();
  }
});